import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useTemplateVariables = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["templateVariables", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patient/template-variables`
      );

      return response.data;
    },
    enabled: !!tenantVal,
    staleTime: 1000 * 60 * 30,
  });
};
